module.exports = __webpack_public_path__ + "img/process-01.128b5a3d.png";